<template>
    <div class="profile-overview">
        <div class="profile-overview-wr-image">
            <img v-if="!show.preloader" class="profile-overview__image" width="64" height="64" :src="srcProfileImage">
            <div v-if="show.preloader" class="preloader">
                <div></div>   
                <div></div>    
                <div></div>    
                <div></div>    
            </div>
            <button
                @click="selectFile"
                class="profile-overview-btn-upload">
                <svg class="profile-overview-btn-upload__image" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.35.34l.038.062.012.019.114.183.024.037.19.306.036.056.267.428.047.075.344.55.059.094.338.54h4.015v10.97H.164V2.69H4.18L5.65.34h4.7zM8 3.474a4.31 4.31 0 100 8.619 4.31 4.31 0 000-8.619zm0 1.567a2.742 2.742 0 110 5.485A2.742 2.742 0 018 5.04zm6.267-.783a.783.783 0 100 1.567.783.783 0 000-1.567z" fill="#2779ED"/></svg>
            </button>
            <input
                class="inp-file" type="file" name="imageUser"
                @change="$store.state.envDev ? uploadImage($event) : uploadImageApi($event)">
            <svg class="profile-overview__art-bg-image" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="100" rx="36" fill="#C0CFE4" fill-opacity=".6"/><rect x="4" y="4" width="92" height="92" rx="35" stroke="#fff" stroke-width="2"/></svg>
        </div>
        <span class="profile-overview__username">{{ this.$store.state.userSession.username }}</span>
        <span class="profile-overview__email">{{ this.$store.state.userSession.email }}</span>
        <div class="profile-overview-date-join">
            <span class="profile-overview-date-join__heading">Katılım</span>
            <span class="profile-overview-date-join__description">Foneturk'e katıldığın tarih</span>
            <span class="profile-overview-date-join__text-date">{{ this.$store.state.userSession.dateJoin }}</span>
            <span class="profile-overview-date-join__art-cake"></span>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                show: {
                    preloader: false,
                }
            };
        },

        computed: {
            srcProfileImage(){
                // return this.$store.state.api.img + this.$store.state.userSession.id + '.jpg';
                return this.$store.state.api.getImage + this.$store.state.userSession.id;
            }
        },

        methods: {
            selectFile(){
                document.querySelector('.inp-file').click();
            },

            uploadImage(event){
                // Check if a file is selected.
                if(!event.currentTarget.files[0]){
                    console.log("no file selected");
                    return;
                }

                // Check the image type.
                let allowedTypes = ['image/png', 'image/jpeg'];
                console.log(event.currentTarget.files);
                if(!allowedTypes.includes(event.currentTarget.files[0].type)){
                    this.$foneturkError({
                        text: 'Seçtiğin resim JPG ya da PNG olmalı.'
                    });
                    event.currentTarget.value = '';
                    return;
                }

                // Check the file size.
                if(event.currentTarget.files[0].size > 10485760){
                    this.$foneturkError({
                        text: 'Seçtiğin resmin boyutu en fazla 10 MB\'yi geçmemeli.',
                    });
                    event.currentTarget.value = '';
                    console.log(event.currentTarget.files);
                    return;
                }

                // Show preloader.
                this.show.preloader = true;

                // Hide preloader.
                setTimeout(() => {this.show.preloader = false;}, 2000);
            },

            uploadImageApi(event){
                // Check if a file is selected.
                if(!event.currentTarget.files[0]){
                    console.log("no file selected");
                    return;
                }

                // Check the image type.
                let allowedTypes = ['image/png', 'image/jpeg'];
                console.log(event.currentTarget.files);
                if(!allowedTypes.includes(event.currentTarget.files[0].type)){
                    this.$foneturkError({
                        text: 'Seçtiğin resim JPG ya da PNG olmalı.'
                    });
                    event.currentTarget.value = '';
                    return;
                }

                // Check the file size.
                if(event.currentTarget.files[0].size > 10485760){
                    this.$foneturkError({
                        text: 'Seçtiğin resmin boyutu en fazla 10 MB\'yi geçmemeli.',
                    });
                    event.currentTarget.value = '';
                    console.log(event.currentTarget.files);
                    return;
                }

                // Show preloader.
                this.show.preloader = true;

                // Send request.
                let fd = new FormData();
                fd.append('imageUser', event.currentTarget.files[0]);

                fetch(this.$store.state.api.uploadImage, {
                    method: 'POST',
                    credentials: 'include',
                    body: fd,
                })
                .then(async response => {
                    this.show.preloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                })
                .then(uploadResponse => {
                    
                })
                .catch(err => {
                    console.error(err);
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/profile-overview.css"></style>